import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ContentContainer } from "components/ContentContainer";
import { theme } from "theme";

export function Content1() {
  return (
    <ContentContainer backgroundColor="secondary">
      <Stack
        id="stack-container"
        sx={{
          [theme.breakpoints.up("md")]: { flexDirection: "row", gap: 2 },
          [theme.breakpoints.down("md")]: { flexDirection: "column", gap: 2 },
        }}
      >
        <LeftContent />
        <RightContent />
      </Stack>
    </ContentContainer>
  );
}

const commonStyle = { flex: "1 1 50%" } as const;

function LeftContent() {
  return (
    <Stack gap={2} sx={commonStyle}>
      <Title />
      <Contact />
      <Address />
    </Stack>
  );
}

function RightContent() {
  return (
    <div style={commonStyle}>
      <img
        src="images/img4.JPG"
        alt=""
        style={{
          maxWidth: "100%",
        }}
      />
    </div>
  );
}

function Title() {
  return (
    <Stack gap={2}>
      <Typography variant="h1">
        <Typography component={"span"} fontWeight={"medium"} fontSize="inherit">
          mgr Ewa Czekańska
        </Typography>
        <br />
        logopeda <br />
        neurologopeda <br />
        terapeuta miofunkcjonalny
      </Typography>
    </Stack>
  );
}

function Address() {
  return (
    <Stack>
      <Typography variant="h2" fontWeight={"medium"}>
        Adres:
      </Typography>
      <Typography variant="body1" component={"address"} fontStyle={"normal"}>
        Specjalistyczny Gabinet Neurologopedyczny <br />
        mgr Ewa Czekańska <br />
        ul. Łukasińskiego 7 I piętro pok. 6 <br />
        37-700 Przemyśl <br />
      </Typography>
    </Stack>
  );
}

function Contact() {
  return (
    <Stack>
      <Typography variant="h2" fontWeight={"medium"}>
        Kontakt:
      </Typography>
      <Typography variant="body1">tel. +48 53 63 72 339</Typography>
      <Typography variant="body1">neurologopeda.przemysl@gmail.com</Typography>
    </Stack>
  );
}
